import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { tomos, tomoIncludes } from '../data/salesData';
export function TomosSection() {
  return <section className="border-b border-[var(--olive)]/30 py-16 sm:py-20" data-id="element-216" data-mp="1p322nfhk38ol">
      <div className="mx-auto max-w-6xl px-4" data-id="element-217" data-mp="1u2na6easkpcx">
        <SectionHeading eyebrow="🏆 El sistema supremo de 365 días" data-id="element-218" data-mp="1u1bx1nvgi595">
          S.O.S. Pilates
        </SectionHeading>
        <p className="mt-4 text-center text-white/70" data-id="element-219" data-mp="xe79bm28etki">
          6 Tomos + 6 Bonos · 336 páginas · Todo el año resuelto
        </p>

        <h3 className="mt-12 text-center text-sm font-semibold uppercase tracking-[0.25em] text-[var(--gold)]" data-id="element-220" data-mp="16d2gb0d3o7ov">
          Los 6 Tomos
        </h3>

        <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-221" data-mp="1bcyj4wa29t2u">
          {tomos.map(tomo => <article key={tomo.title} className="rounded-2xl border border-[var(--olive)]/40 bg-[#0d0f08] p-6 transition-colors hover:border-[var(--gold)]/50" data-id="element-222" data-mp="2hrpphfhye649">
              <span className="text-3xl" aria-hidden="true" data-id="element-223" data-mp="2qnp4qaqfli8b">
                {tomo.emoji}
              </span>
              <h4 className="mt-4 font-serif-display text-xl font-bold text-[var(--cream)]" data-id="element-224" data-mp="2mkiyh33bjr1u">
                {tomo.title}
              </h4>
              <p className="mt-2 text-sm text-white/65" data-id="element-225" data-mp="2coz3qk0hqyeo">{tomo.description}</p>
            </article>)}
        </div>

        <div className="mt-12 rounded-2xl border border-[var(--gold)]/30 bg-[#12140b] p-6 sm:p-8" data-id="element-226" data-mp="27qecha37vp2d">
          <h3 className="font-serif-display text-2xl font-bold text-[var(--cream)]" data-id="element-227" data-mp="22xl84nbnuiqt">
            Cada tomo incluye:
          </h3>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-228" data-mp="1yuydyfriolqg">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-229" data-mp="1tvv9oxjd2jjj">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[var(--olive)]/30" data-id="element-230" data-mp="1oxjyojhby2zq">
                  <CheckIcon className="h-4 w-4 text-[var(--olive-light)]" aria-hidden="true" data-id="element-231" data-mp="1k1v7b3fgrsei" />
                </span>
                <span className="text-white/80" data-id="element-232" data-mp="1aeirxekp8870">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}